const ACCESS_STATUSES = new Set(["active", "trialing", "past_due"]);

export interface SubscriptionAccessState {
  trial: { endsAt: number | null };
  subscription: { status: string } | null;
}

export function subscriptionGrantsAccess(
  state: SubscriptionAccessState | undefined,
) {
  return Boolean(
    state?.subscription && ACCESS_STATUSES.has(state.subscription.status),
  );
}

export function trialDaysRemaining(
  endsAt: number | null | undefined,
  now = Date.now(),
) {
  if (!endsAt || endsAt <= now) return 0;
  return Math.max(1, Math.ceil((endsAt - now) / 86_400_000));
}

export function subscriptionRequiresPayment(
  state: SubscriptionAccessState | undefined,
  forced = false,
  now = Date.now(),
) {
  if (forced) return true;
  if (!state || subscriptionGrantsAccess(state)) return false;
  if (state.subscription) return true;
  return !state.trial.endsAt || state.trial.endsAt <= now;
}
